module.exports = __webpack_public_path__ + "img/128.6b68e189.jpg";